var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationParts = function SvgGeneralInformationParts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.625h-.75V3.75h5.625v.75H4.5zM20.25 8.625h-.75V4.5h-4.875v-.75h5.625zM20.25 20.25h-5.625v-.75H19.5v-4.125h.75zM12.015 8.985a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 .75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25-2.25-1.01-2.25-2.25 1.01-2.25 2.25-2.25M9.375 20.25h-3a2.63 2.63 0 0 1-2.625-2.625v-2.25h.75v2.25c0 1.034.841 1.875 1.875 1.875h3z"
  }))));
};
export default SvgGeneralInformationParts;